//@mui
import { Box, Typography, useTheme } from "@mui/material";

export default function CoverHeadline() {
  const theme = useTheme();
  return (
    <Box sx={{ textAlign: "center" }}>
      <Typography variant="h4" sx={{
        mb: 3
      }}>
        Get full competitive research coverage
      </Typography>
      <Typography
        sx={{
          maxWidth: "650px",
          margin: "0 auto",
          color: theme.palette.grey[500],
        }}
      >
        Set your marketing strategies for maximum impact with all encompassing
        competitive intel and website traffic analysis.
      </Typography>
    </Box>
  );
}
